// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__f0IwH","index":"styles_index__30QX9"};